'use strict';

exports.__esModule = true;
exports.flexShrink = exports.flexGrow = undefined;

var _styledSystem = require('styled-system');

var flexGrow = exports.flexGrow = (0, _styledSystem.style)({
  prop: 'flexGrow'
});
var flexShrink = exports.flexShrink = (0, _styledSystem.style)({
  prop: 'flexShrink'
});
exports["default"] = (0, _styledSystem.compose)(_styledSystem.flex, _styledSystem.flexBasis, flexGrow, flexShrink, _styledSystem.justifySelf, _styledSystem.alignSelf, _styledSystem.order);